<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row mb-3">
                <div
                  class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center"
                >
                  <div class="w-25 mx-1">
                    <datepicker
                      input-class="form-control form-control-modern bg-body"
                      :monday-first="true"
                      :full-month-name="true"
                      :language="bs"
                      :format="customFormatter"
                      v-model="dateFrom"
                    ></datepicker>
                  </div>

                  <div class="w-25 mx-1">
                    <datepicker
                      input-class="form-control form-control-modern bg-body"
                      :monday-first="true"
                      :full-month-name="true"
                      :language="bs"
                      :format="customFormatter"
                      v-model="dateTo"
                    ></datepicker>
                  </div>

                  <treeselect
                    v-model="companyId"
                    class="w-25 form-control form-control-modern bg-body"
                    loadingText="Učitavanje..."
                    noResultsText="Nema rezultata"
                    searchPromptText="Unesite naziv komitenta"
                    :load-options="loadCompanies"
                    :async="true"
                    :options="companies"
                    placeholder="Izaberite komitenta"
                  />

                  <treeselect
                    v-model="b2bOrb2c"
                    class="w-25 mx-1 form-control form-control-modern"
                    :options="b2bOrb2cOptions"
                    placeholder="B2B/B2C"
                  />
                </div>
                <div class="col-4 d-flex justify-content-end">
                  <div class="row col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                    <div
                      class="d-flex align-items-lg-center flex-column flex-lg-row"
                    >
                      <label class="ws-nowrap me-3 mb-0">Show:</label>
                      <select
                        class="form-control select-style-1 results-per-page"
                        name="results-per-page"
                        v-model="searchConfig.pageSize"
                        @change="changePageSize(searchConfig.pageSize)"
                      >
                        <option
                          :value="page"
                          v-for="page in pageSizeList"
                          :key="page"
                        >
                          {{ page }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-lg-auto ps-lg-1">
                    <div
                      class="search search-style-1 search-style-1-lg mx-lg-auto"
                    >
                      <div class="input-group">
                        <input
                          type="text"
                          class="search-term form-control"
                          placeholder="Search"
                          v-model="searchField"
                          @input="debounceInput"
                        />
                        <button class="btn btn-default" type="submit">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="dataTables_wrapper dt-bootstrap5 no-footer"
              v-if="list.length > 0"
            >
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting" @click="handleSort('id')">
                        <i class="fa fa-fw fa-sort"></i>
                        RBR
                      </th>
                      <th class="sorting" @click="handleSort('companyTitle')">
                        <i class="fa fa-fw fa-sort"></i>
                        Komitent
                      </th>
                      <th>Ime i prezime</th>
                      <th class="sorting" @click="handleSort('createdDate')">
                        <i class="fa fa-fw fa-sort"></i>
                        Datum kreiranja
                      </th>
                      <th>B2B/B2C</th>
                      <th class="sorting" @click="handleSort('totalAmountVat')">
                        <i class="fa fa-fw fa-sort"></i>
                        Porez
                      </th>
                      <th class="sorting" @click="handleSort('total')">
                        <i class="fa fa-fw fa-sort"></i>
                        Ukupno
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(order, index) in list"
                      :key="order.id"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                      @click="openDetails(order.id)"
                      :title="`Otvori detalje narudžbe ${order.id}`"
                    >
                      <td>
                        <strong> {{ order.id }} </strong>
                      </td>
                      <td>
                        {{ order.company || 'N/A' }}
                      </td>
                      <td>
                        {{ order.userFullName }}
                      </td>
                      <td>{{ formatMomentDate(order.createdDate) }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="[
                            order.b2B ? 'bg-light text-dark' : 'bg-dark',
                          ]"
                        >
                          {{ order.b2B ? 'B2B' : 'B2C' }}
                        </span>
                      </td>
                      <td>{{ order.totalAmountVat | money2 }}</td>
                      <td>{{ order.totalAmount | money2 }}</td>
                      <!-- <td @click="showOrderItems(order)">
                        <span role="button">
                          <i class="fas fa-external-link-alt"></i>
                        </span>
                      </td> -->
                      <td>
                        <router-link
                          :to="{ name: 'EditOrderArticles', params: { id: order.id } }"
                        >
                          <span role="button">
                            <i class="fas fa-external-link-alt"></i>
                          </span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }}
                <a class="alert-link" @click.prevent="resetFilters">{{
                  translations.resetFilters
                }}</a
                >.
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination
                    :action="actionName"
                    :pagination-props="paginationProps"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="articleModalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="handleBulkAction"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="order-modal" v-if="order" css-class="modal-xl">
      <h5 slot="header">
        <strong>Narudžba br. {{ order.id }}</strong>
      </h5>
      <div slot="body">
        <table class="table table-stripped">
          <thead>
            <th>Artikal</th>
            <th>Količina</th>
            <th>Cijena</th>
            <th>Ukupno</th>
          </thead>
          <tbody>
            <tr v-for="item in order.orderItems" :key="item.id">
              <td>{{ item.article }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.price | money2 }}</td>
              <td>{{ item.totalAmount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer"></div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import api from '@/services/api';

import { format } from 'date-fns';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations, pager } from '@/mixins';
import Pagination from '../shared/Pagination.vue';
import Modal from '../shared/modal/Modal.vue';
import helpers from '@/services/helpers';

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 15);
export default {
  components: {
    Treeselect,
    Datepicker,
    Pagination,
    Modal,
  },
  name: 'OrderArticles',
  mixins: [translations, pager],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getShoppingCarts',
      deleteActionName: 'toBeDefined',
      order: null,
      companyId: query?.companyId ? parseInt(query.companyId, 10) : null,
      dateFrom: query?.dateFrom ? new Date(query.dateFrom) : currentDate,
      dateTo: query?.dateTo ? new Date(query.dateTo) : new Date(),
      b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
    };
  },
  computed: {
    bs() {
      return bs;
    },
    b2bOrb2cOptions() {
      return [
        { id: 'b2b', label: 'B2B' },
        { id: 'b2c', label: 'B2C' },
        { id: 'all', label: 'Sve' },
      ];
    },
    list() {
      return this.$store.getters.getShoppingCarts;
    },
    articleModalText() {
      return this.translations.areYouSureSelected;
    },
    companies() {
      const companies = this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
      return companies;
    },
    paginationProps() {
      return {
        companyId: this.companyId,
        dateFrom: `${this.formatDate(
          this.dateFrom,
          'yyyy-MM-dd'
        )}T00:00:00.000Z`,
        dateTo: `${this.formatDate(this.dateTo, 'yyyy-MM-dd')}T23:59:59.000Z`,
        orderStatus: this.orderStatus,
        b2b: this.b2bOrb2c === 'b2b' ? true : null,
        b2c: this.b2bOrb2c === 'b2c' ? true : null,
      };
    },
    problemStatuses() {
      return helpers.getProblemStatusesAsArray();
    },
  },
  methods: {
    mergeOrders() {
      api
        .mergeOrders(this.selected)
        .then((response) => {
          this.$toast.info(response?.data?.info);
          this.$store.dispatch(this.actionName, {
            ...this.searchConfig,
            ...this.paginationProps,
          });
        })
        .catch(() => {
          this.$toast.error('Desila se greška');
        });
    },
    formatDate(date, dateFormat = 'dd.MM.yyyy, HH:mm') {
      return format(new Date(date), dateFormat);
    },
    formatMomentDate(date, dateFormat = 'DD.MM.yyyy, HH:mm') {
      const formattedDate = moment.utc(date).local().format(dateFormat);
      return formattedDate;
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    mapDeliveryType(order) {
      switch (order.deliveryType) {
        case 1:
          return 'Lično preuzimanje';
        case 2:
          return order.expressPost.title;
        case 3:
          return 'Naša dostava';
        default:
          return 'N/A';
      }
    },
    showOrderItems(order) {
      this.order = order;
      this.$nextTick(() => {
        $('#order-modal').modal('show');
      });
    },
    loadCompanies({ callback, searchQuery }) {
      this.$store
        .dispatch('getCompanies', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          skipPager: true,
        })
        .then(() => {
          callback(null, this.companies);
        });
    },
    openDetails(orderId) {
      this.$router.push({ name: 'EditOrderArticles', params: { id: orderId } });
    },
    getOrders() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  mounted() {
    const { query } = this.$route;

    this.$store.dispatch(this.actionName, {
      ...this.searchConfig,
      ...this.paginationProps,
      page: query?.page ? parseInt(query.page, 10) : 1,
    });
    this.$store.dispatch('getCompanies', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
      skipPager: true,
    });
  },
  watch: {
    companyId() {
      this.getOrders();
    },
    dateFrom() {
      this.getOrders();
    },
    dateTo() {
      this.getOrders();
    },
    b2bOrb2c() {
      this.getOrders();
    },
  },
};
</script>

<style>
.vue-treeselect__placeholder {
  color: #000;
}

.form-control.form-control-modern.vue-treeselect.vue-treeselect--open-below.vue-treeselect--searchable.vue-treeselect--single.w-25 {
  height: 46px;
}

.vue-treeselect__control {
  border: none;
  background: none;
}
</style>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>
